import { fork, take } from 'redux-saga/effects';
import authSaga from './auth/index';
import devicesSaga from './devices';
import infoEventsSaga from './infoEvents';
import statisticsSaga from './statistics';
import ridesSaga from './rides';
import dashboardSaga from './dashboard';
import settings from './settings';
import contracts from './contracts';
import sidebarTooltipSaga from './sidebar-tooltip';
import billsSaga from './bills';
import geozonesSaga from './geozones';

function* routerSaga() {
  const { payload } = yield take('@@router/LOCATION_CHANGE');

  if (payload.pathname === '/rides') {
    document.querySelector('body').classList.add('full-map-main');
  } else {
    document.querySelector('body').classList.remove('full-map-main');
  }
}

export default function* rootSaga() {
  yield fork(contracts);
  yield fork(authSaga);
  yield fork(devicesSaga);
  yield fork(infoEventsSaga);
  yield fork(statisticsSaga);
  yield fork(routerSaga);
  yield fork(ridesSaga);
  yield fork(dashboardSaga);
  yield fork(settings);
  yield fork(sidebarTooltipSaga);
  yield fork(billsSaga);
  yield fork(geozonesSaga);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js